
seedWebApp.controller('OrderAcceptModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'order',
    function OrderAcceptModalController($scope, $uibModalInstance, TranslationService, order) {

        $scope.translation = TranslationService.getActiveTranslation();
        console.log('OrderAcceptModalCtrl.order');

        console.log(order);
        $scope.order = order;


        if (order.obs_rejeicao) {
             order.RejectComments = order.obs_rejeicao;
        }
        if (order.observacao) {
            order.AcceptComments = order.observacao;
        }

        $scope.accept = function () {
            $uibModalInstance.close();
        };

        $scope.reject = function () {
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.seqIDFunction = function (detail) {
            if (detail.SeqID) {
                return Number(detail.SeqID);
            }
            else {
                return 0;
            }
        };

    }]
);